// @flow

import engine from 'store/src/store-engine'
import localStorage from 'store/storages/localStorage'
import sessionStorage from 'store/storages/sessionStorage'
import memoryStorage from 'store/storages/memoryStorage'
import cookieStorage from 'store/storages/cookieStorage'
import expirePlugin from 'store/plugins/expire'

type Store = {
  set: (string, any, expireDate?: string | number) => void,
  get: string => any,
  remove: string => void,
  clearAll: () => void,
  each: (callback: (value: any, key: string) => void) => void
};

export const localStore: Store = engine.createStore(localStorage)
export const sessionStore: Store = engine.createStore(sessionStorage)
export const memoryStore: Store = engine.createStore(memoryStorage)
export const cookieStore: Store = engine.createStore(cookieStorage, [
  expirePlugin
])

export function getStore (storeType: string): Store {
  switch (storeType) {
    case 'sessionStore':
      return sessionStore
    case 'localStore':
      return localStore
    case 'cookieStore':
      return cookieStore
    default:
      return memoryStore
  }
}



// WEBPACK FOOTER //
// ./src/frame/core/store.js